import { ReactElement } from 'react';

import { useCharityStyle } from '../../../Shared/useCharityStyle';
import { SharedProps } from '../../types';
import Container from '../../UI/Container';
import Layout from '../../UI/Layout';
import EditProjectMailForm, { EditProjectMailFormProps } from './EditProjectMailForm';
import { ProjectLayout } from './ProjectLayout';

export interface EditProjectMailPageProps extends SharedProps {
  project: EditProjectMailFormProps['project'] & {
    new_campaign_mail_enabled: boolean;
    reminder_mail_enabled: boolean;
    target_reached_mail_enabled: boolean;
    upcoming_event_mail_enabled: boolean;
    upcoming_event_reminder_mail_enabled: boolean;
  };
  charity: EditProjectMailFormProps['charity'];
  name: EditProjectMailFormProps['name'];
}

export default function EditProjectMailPage({
  project,
  charity,
  name,
  auth: { user },
}: EditProjectMailPageProps) {
  useCharityStyle(charity);

  return (
    <Container>
      <EditProjectMailForm
        name={name}
        project={project}
        charity={charity}
        user={user}
      />
    </Container>
  );
}

EditProjectMailPage.layout = (page: ReactElement<SharedProps>) => {
  return <Layout {...page.props}><ProjectLayout>{page}</ProjectLayout></Layout>;
};
